import { PaceEnvironment } from '@evorait/pace-environment';

export const environment: PaceEnvironment = {
    production: true,
    operateInMockMode: false,
    appId: 'com.siemens.medical.solutions.usa.pacepwa',
    apiBase: 'https://pace-prod-backend-png101.azurewebsites.net',
    apiSapProxy: 'api/v1/proxy',
    reportIssueSupportEmail: 'healthcaretest@service-now.com',
    bundleIdentifierName: 'PACE',
    subscriptionServerPublicKey:
        'BGXPTVy72unf7at8QszwD9YXjraFD5JEIS5lpi4q8T46hSTCcZy2fOrfrKBn2kPt4QvlQ28fk2LEAzbyTo3TAPQ',
    msal: {
        clientId: '9fddb7f6-3c46-485c-af42-68bb81dd6c27',
        authority: 'https://login.microsoftonline.com/5dbf1add-202a-4b8d-815b-bf0fb024e033',
        fxAppScope: 'api://47641922-c2ac-464b-a3c1-606dd80d4903/user_impersonation',
        btpApimScope: 'api://20a1d762-b6cc-4fb8-a343-04087124cc93/read',
        graphApiUrl: 'https://graph.microsoft.com/v1.0/me',
    },
    appInsightsConnectionString:
        'InstrumentationKey=e0cefb5c-0922-47b8-9582-6745f9e68313;IngestionEndpoint=https://germanywestcentral-1.in.applicationinsights.azure.com/;LiveEndpoint=https://germanywestcentral.livediagnostics.monitor.azure.com/;ApplicationId=49ee45ef-83f5-478d-9208-d8289cf4135d',
    enableNgRx: true,
};
